export default {
    api: 'https://api.witart.fr',
    picture_url: 'https://api.witart.fr/api/v1/witapp/picture',
};
